import { Component, Inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatButtonModule } from "@angular/material/button"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"

@Component({
  selector: "app-decline-modal",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: "./decline-modal.component.html",
  styleUrls: ["./decline-modal.component.css"],
})
export class DeclineModalComponent {
  missingInformation = ""
  explanation = ""
  sending = false

  constructor(
    public dialogRef: MatDialogRef<DeclineModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: unknown,
  ) {}

  submit(): void {
    if (!this.explanation.trim() || this.sending) return
    this.sending = true
    this.dialogRef.disableClose = true
    const result = {
      missing_information: this.missingInformation || "",
      explanation: this.explanation.trim(),
    }
    /* Brief delay so the spinner can paint before the overlay closes */
    setTimeout(() => this.dialogRef.close(result), 100)
  }
}
